import React, { useEffect, useState } from "react";
import { styled } from "@linaria/react";
import { useAvivaSelector } from "@redux/hook";
import { css } from "@linaria/core";
import Icon from "@components/_Revamp/Icon";
import _, { isEmpty } from "lodash";
import { Text } from "./../Components/Text";
import { SHIELD_STARTER_HELTH_PLUS } from "@static/staticConstents";
import { Helpers } from "@utils/helpers";
export interface SheetContainerProps {
  isVisible?: boolean;
}
export interface BottomSheetContainerProps {
  isDisplaying?: boolean;
}

const ProductOverviewMobile = () => {
  const policyName = useAvivaSelector(
    (state) => state.shieldStarterStep2.policyName
  );
  const planOverview = useAvivaSelector(
    (state) => state.shieldStarterStep2.planOverview
  );
  const rawQuotaion = useAvivaSelector(
    (state) => state.shieldStarterStep2.rawQuotaion
  );

  const isQuoteConfirm = !isEmpty(rawQuotaion);
  const [tempPlanOverview, setTempPlanOverview] = useState<any>([]);
  const [tempPremiumBreackdown, setTempPremiumBreackdown] = useState<any>([]);
  const [isContentDisplay, setIsContentDisplay] = useState<boolean>(false);

  useEffect(() => {
    if (planOverview) {
      const pName =
        policyName === SHIELD_STARTER_HELTH_PLUS
          ? "Singlife Shield Starter\nand Health Plus Starter"
          : policyName;

      const promoCode = planOverview?.PlanOverViewData?.promoCode;
      let promoCodeText = "Promo Code";
      let promoCodeValue = "-";

      if (promoCode) {
        promoCodeText = `Promo Code \n<b>${promoCode}</b>${promoCode?.includes ('GST')?" (GST waiver for first year)":""}`;
        promoCodeValue = planOverview?.PlanOverViewData?.promoCodeDiscount;
      }

      const Overview = [
        {
          text: "Plan Selected",
          value: pName,
        },
        {
          text: "Policy Term",
          value: "Yearly Renewable",
        },
        {
          text: "Premium Term",
          value: "Yearly Renewable",
        },
      ];

      setTempPlanOverview(Overview);
      let shps = "";
      if (policyName === SHIELD_STARTER_HELTH_PLUS) {
        shps = "Singlife Health Plus Starter";
      }
      const Premium = [
        {
          text: "Singlife Shield Starter",
          value: Helpers.toCurrency(
            Number(planOverview?.PlanOverViewData?.basePlanPriceNoGst) || 0
          ),
        },
        {
          text: shps,
          value: Helpers.toCurrency(
            Number(planOverview?.PlanOverViewData?.riderPlanPriceNoGst) || 0
          ),
        },
        {
          text: "CPF MediSave deduction",
          value: `-${Helpers.toCurrency(
            Number(planOverview?.PlanOverViewData?.MediSaveDeduction) || 0
          )}`,
        },
        {
          text: promoCodeText,
          value: `-${Helpers.toCurrency(Number(promoCodeValue) || 0)}`,
        },
      ];

      setTempPremiumBreackdown(Premium);
    }
  }, [planOverview]);

  useEffect(() => {
    if (isContentDisplay) {
      document.body.style.overflow = "hidden";
      document.body.style.touchAction = "none";
    } else {
      document.body.style.overflow = "unset";
      document.body.style.touchAction = "unset";
    }
  }, [isContentDisplay]);

  const toggleDisplay = () => {
    setIsContentDisplay(!isContentDisplay);
  };

  return (
    <div>
      <OverlayDiv
        onClick={() => {
          setIsContentDisplay(false);
        }}
        className={
          isContentDisplay
            ? `${OverlayDiv} ${OverlayDivVisible}`
            : `${OverlayDiv}`
        }
      ></OverlayDiv>
      <ContainerWrapper isVisible={isQuoteConfirm}>
        <UpperContainer isDisplaying={isContentDisplay}>
          <UperWrap firstSpan>
            <span style={{ color: "#FFF", alignItems: "center" }}>
              <span>Quote:</span>{" "}
              <span style={{ fontSize: "18px" }}>
                {Helpers.toCurrency(
                  Number(planOverview?.PlanOverViewData?.subTotalAmount) || 0
                )}
                /year
              </span>
            </span>
            <span onClick={toggleDisplay}>
              <AccountBalanceValue>
                {isContentDisplay ? "Collapse" : "Expand"}
              </AccountBalanceValue>
              <Icon
                className={
                  !isContentDisplay
                    ? `${IconRotate} ${IconPosition}`
                    : IconPosition
                }
                name={"circle-down-arrow-purple"}
              />
            </span>
          </UperWrap>
          <UperWrap className={addscroll}>
            <Tag>Singlife Shield Starter</Tag>
            {policyName === SHIELD_STARTER_HELTH_PLUS && (
              <Tag>Singlife Health Plus Starter</Tag>
            )}
          </UperWrap>
        </UpperContainer>
        <BottomContentContainerWrapper isDisplaying={isContentDisplay}>
          <ListingContainer margin={"0"}>
            <Text variant="title" margin="0px 0px 8px 0px" color="#ffffff">
              Plan Overview
            </Text>
            {tempPlanOverview?.map((entries: any) => {
              return (
                <DataList>
                  <span>{entries.text}</span>
                  <span>{entries.value}</span>
                </DataList>
              );
            })}
            <Text variant="title" margin="24px 0px 8px 0px" color="#ffffff">
              Annual Premium Breakdown*
            </Text>
            {tempPremiumBreackdown?.map((entries: any) => {
              return entries.text ? (
                <DataList>
                  <span dangerouslySetInnerHTML={{ __html: entries.text }} />
                  <span>{entries.value}</span>
                </DataList>
              ) : null;
            })}
            <hr
              style={{ borderBottom: "1px solid #C4C4C4", margin: "24px 0" }}
            />
            <DataList>
              <span style={{ fontSize: "12px" }}>
                <b style={{ color: "#DFC2DD", fontSize: "18px" }}>
                  Cash Payment
                </b>{" "}
                <br /> (after CPF MediSave Deduction)
              </span>
              <span style={{ color: "#DFC2DD", fontSize: "18px" }}>
                {Helpers.toCurrency(
                  Number(planOverview?.PlanOverViewData?.totalCashPayble) || 0
                )}
              </span>
            </DataList>
            <DataList>
              <span style={{ fontSize: "12px", marginTop: "16px" }}>
                *Premiums quoted after GST
              </span>
            </DataList>
          </ListingContainer>
        </BottomContentContainerWrapper>
      </ContainerWrapper>
    </div>
  );
};

export default ProductOverviewMobile;

const ContainerWrapper = styled.div<SheetContainerProps>`
  display: none;
  z-index: 101;
  position: fixed;
  background-color: #434343;
  bottom: 0;
  left: 0;
  right: 0;
  border-radius: 16px 16px 0 0;
  @media screen and (max-width: 767px) {
    display: ${(props) => (props.isVisible ? "block" : "none")};
  }
`;

const UpperContainer = styled.div<BottomSheetContainerProps>`
  justify-content: center;
  height: auto;
  padding-top: 16px;
  padding-bottom: ${(props) => (props.isDisplaying ? "24px" : "48px")};
`;

const MenuIcon = styled.img`
  width: 18px;
  height: 18px;
  object-fit: contain;
`;

const AccountBalanceValue = styled.p`
  color: #dfc2dd;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.4;
  letter-spacing: 0.48px;
`;

const IconPosition = css`
  color: #883e89;
  width: 20px;
  height: 20px;
  object-fit: scale-down;

  @media screen and (min-width: 768px) {
    right: 0;
  }
  transform: translateY(-10%);
`;

const IconRotate = css`
  transform: translateY(-10%) rotate(180deg);
`;

const BottomContentContainerWrapper = styled.div<BottomSheetContainerProps>`
  z-index: 50;
  padding: 0 24px;
  display: block;
  max-height: ${(props) => (props.isDisplaying ? "600px" : "0px")};
  transition: max-height 0.3s linear;
  padding-top: ${(props) => (props.isDisplaying ? "24px" : "0px")};
  padding-bottom: ${(props) => (props.isDisplaying ? "48px" : "0px")};
  border-top: 1px solid #c4c4c4;
`;

const OverlayDiv = styled.div`
  z-index: 100;
  position: fixed;
  right: 0;
  top: 0;
  bottom: 0;
  left: 0;
  opacity: 0;
  visibility: hidden;
  background-color: rgba(1, 1, 1, 0.5);
  transition: visibility 0.3s, opacity 0.3s linear;
`;

const OverlayDivVisible = css`
  opacity: 1;
  visibility: visible;
  @media screen and (min-width: 768px) {
    opacity: 0;
    visibility: hidden;
  }
`;
const summary = { text: "Total Annual Premium", value: "-" };

export interface FormContainerProps {
  margin?: string;
}

const ListingContainer = styled.div<FormContainerProps>``;

const DataList = styled.div`
  display: flex;
  margin-bottom: 8px;
  justify-content: space-between;

  span {
    font-size: 14px;
    color: #ffffff;
    white-space: pre;
    letter-spacing: 0.48px;
  }
  & span:nth-child(1) {
    flex-wrap: wrap;
    width: 60%;
  }
  & span:nth-child(2) {
    display: flex;
    justify-content: flex-end;
    text-align: right;
    font-weight: 600;
  }
`;

const UperWrap = styled.div<{ firstSpan?: boolean }>`
  display: flex;
  gap: 8px;
  justify-content: ${(props) => (props.firstSpan ? "space-between" : "")};
  margin-bottom: ${(props) => (props.firstSpan ? "10px" : "")};
  padding: 0 24px;
  span {
    font-size: 12px;
    font-weight: 600;
    line-height: 140%;
    letter-spacing: 0.48px;
    display: flex;
    gap: 10px;
  }
`;

const Tag = styled.span`
  padding: 4px 8px;
  border-radius: 8px;
  background: #f5f5f5;
  color: #434343;
  white-space: nowrap;
`;

const addscroll = css`
  overflow-x: auto;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none;  /* Internet Explorer 10+ */

  &::-webkit-scrollbar { /* WebKit */
    width: 0;
    height: 0;
  }
`;
